export default "__VITE_ASSET__d2ee2c7e__"